import { UserRole } from './types';

export const ROLES: Record<UserRole, { label: string; description: string }> = {
  crew: { label: 'Station Staff', description: 'Submit requests for what the station needs' },
  logistics: {
    label: 'Logistics',
    description: 'Consolidate requests into orders, adjust lines, and send vendor orders',
  },
  admin: { label: 'Admin', description: 'Manage items, vendors, users, and system config' },
};

// Linear privilege hierarchy — mirrors the worker RBAC ladder.
export const ROLE_RANK: Record<UserRole, number> = { crew: 0, logistics: 1, admin: 2 };
